<div class="security">
  <div *ngFor="let item of listItems" class="security-items">
    <img alt ="password icon" [src]="getImageStatus(item.status)" />

    <p>
      {{ item.label }}
      <span
        class="tooltip"
        (click)="fltrInfoTooltip.toggle()"
        (keydown.enter)="fltrInfoTooltip.toggle()"
        *ngIf="item.tooltipText"
      >
        <i-feather
          #fltrInfoTooltip="matTooltip"
          name="info"
          [matTooltip]="item.tooltipText"
          matTooltipPosition="below"
          matTooltipClass="custom-mat-tooltip"
        ></i-feather>
      </span>
    </p>
  </div>
</div>
